import React from "react";
import {Grid, WindowScroller} from "react-virtualized";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import SelectionGridItem from "./selectionGridItem";
import LoadingSpinner from "../../ui/loadingSpinner";
import {getWithFilters, useGetFiltersRequest} from "./gridFunctions";
import SelectionMainVirtualizedFiltersGridMobile from "./selectionMainVirtualizedFiltersGridMobile";
import SelectionGridWizardGroupItem from "./selectionGridWizardGroupItem";
import {wizardGroupInterface} from "../../../interfaces/wizardItemInterface";
import {displayMaterialsWizardGroupAsFeature} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";

const SelectionMainVirtualizedGridMobile = (props) => {

  const {currentParent, currentFeatures, handleFeatureClick, handleUserLoginClick, listItemHeight, currentGroups,
    onScroll, selectionWindowView, checkIfFeatureSelected, scrollElement, filterGroups, fabricatorData, isWizard} = props;

  const {withFilters, filtersLoading} = getWithFilters(currentParent, currentFeatures, filterGroups, fabricatorData);

  useGetFiltersRequest(isWizard, filtersLoading, currentParent, filterGroups);

  if (filtersLoading) {
    return <LoadingSpinner/>
  }

  if (withFilters) {
    return <SelectionMainVirtualizedFiltersGridMobile currentParent={currentParent}
                                                      scrollElement={scrollElement}
                                                      onScroll={onScroll}
                                                      checkIfFeatureSelected={checkIfFeatureSelected}
                                                      currentFeatures={currentFeatures}
                                                      handleFeatureClick={handleFeatureClick}
                                                      handleUserLoginClick={handleUserLoginClick}
                                                      listItemHeight={listItemHeight}/>
  }

  const columnWidth = selectionWindowView === 1 ? listItemHeight - 14 : (listItemHeight - 6)/2;

  // const columnsLength = currentFeatures.length; // no empty features anymore!
  // const container = document.querySelector(".selection-main__bv-item");
  // const minColumns = container && Math.ceil(container.clientWidth / columnWidth) - 1;
  // if (minColumns && (selectionWindowView === 2) && (columnsLength < minColumns)) {
  //   for (let i = 1; i <= minColumns - columnsLength;i++) {
  //     currentFeatures.push(<div className="feature feature--empty"/>);
  //     currentFeatures.push(<div className="feature feature--empty"/>);
  //   }
  // }

  const navigationViewType = selectionWindowView === 3 ? 2 : selectionWindowView; // 2
  const columnsCount = Math.ceil(currentFeatures.length / navigationViewType); // for ex. 28/3 = 10 columns

  // console.log("navigationViewType", navigationViewType);
  // console.log("currentFeatures", currentFeatures);
  // console.log("columnsCount", columnsCount);
  // console.log("columnWidth", columnWidth);
  // console.log("currentParent", currentParent);
  // console.log("scrollElement", scrollElement);
  // console.log("this.props.listItemHeight", listItemHeight);

  const cellRenderer = ({columnIndex, key, rowIndex, style}) => {
    let index = (navigationViewType * columnIndex) + rowIndex;
    if (!currentFeatures[index]) {
      // return <div key={key} style={style}><div className="feature feature--empty" key={"feature" + index}/></div>
      return null
    }
    if (isWizard && displayMaterialsWizardGroupAsFeature(currentGroups)) {
      if (!currentFeatures[index].id) {
        return null
      }
      return (
        <div key={key} style={style}>
          <SelectionGridWizardGroupItem styles={{}}
                                        handleFeatureClick={handleFeatureClick}
                                        wizardGroup={currentFeatures[index]}  />
        </div>
      )
    }
    return (
      <div key={key} style={style}>
        <SelectionGridItem
          styles={{}}
          currentFeature={currentFeatures[index]}
          checkIfFeatureSelected={checkIfFeatureSelected}
          handleFeatureClick={handleFeatureClick}
          handleUserLoginClick={handleUserLoginClick}
          isWizard={isWizard}
          wizardGroup={currentGroups ? currentGroups[0] : null}/>
      </div>
    )
  }

  return (
    <WindowScroller scrollElement={scrollElement}>
      {/*{({ height, isScrolling, onChildScroll, scrollTop, width }) => (*/}
      {() => {
        const width = scrollElement.clientWidth || 0;
        return (
          <Grid rowCount={navigationViewType}
                columnCount={columnsCount}
                width={width}
                height={(columnWidth * navigationViewType) - 1}
                onScroll={onScroll}
                columnWidth={columnWidth}
                rowHeight={columnWidth}
                cellRenderer={cellRenderer}>
          </Grid>
        )
      }}
    </WindowScroller>
  )
}

SelectionMainVirtualizedGridMobile.propTypes = {
  currentFeatures: PropTypes.array,
  handleFeatureClick: PropTypes.func.isRequired,
  handleUserLoginClick: PropTypes.func.isRequired,
  checkIfFeatureSelected: PropTypes.func.isRequired,
  onScroll: PropTypes.func,
  currentParent: PropTypes.object,
  listItemHeight: PropTypes.number,
  scrollElement: PropTypes.any, // div
  isWizard: PropTypes.bool,
  currentGroups: PropTypes.arrayOf(PropTypes.shape(wizardGroupInterface)),
}

const mapStateToProps = (store) => {
  const {selectionWindowView} = store.selectionState;
  return {
    filterGroups: store.filterState.filterGroups,
    fabricatorData: store.fabricatorState,
    selectionWindowView
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(SelectionMainVirtualizedGridMobile)
